import script from "./SubFlowConfigPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SubFlowConfigPanel.vue?vue&type=script&setup=true&lang=js"

import "./SubFlowConfigPanel.vue?vue&type=style&index=0&id=2bdec924&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bdec924"]])

export default __exports__